import { useEffect } from 'react'

function upsertMeta(name: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

// /insights and /insights/admin share one static index.html shell (a
// single fixed <title>, no meta description), so per-route SEO needs to be
// set here on the client instead — there's no per-page HTML file to edit
// the way the 7 static marketing pages work.
export function useDocumentMeta(
  title: string,
  options?: { description?: string; noindex?: boolean }
) {
  useEffect(() => {
    document.title = title

    if (options?.description) {
      upsertMeta('description', options.description)
    }

    // /insights is public content and belongs in search results;
    // /insights/admin is a private review tool that should never be indexed.
    upsertMeta('robots', options?.noindex ? 'noindex, nofollow' : 'index, follow')
  }, [title, options?.description, options?.noindex])
}
